import { render, staticRenderFns } from "./NewGroupModal.html?vue&type=template&id=40943f23&scoped=true&"
import script from "./NewGroupModal.vue?vue&type=script&lang=js&"
export * from "./NewGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./NewGroupModal.scss?vue&type=style&index=0&id=40943f23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40943f23",
  null
  
)

export default component.exports